import React, { useState } from 'react';
import { PlusCircleIcon, LinkIcon } from '@heroicons/react/24/solid';
import { formatDate } from 'shared_items/formatConventions';
import { TYPE_COLORS } from '../moduleComponents/DropdownType';
import ModalRecordForm from './ModalRecordForm';
import { FiltersRecords } from '../moduleComponents/FiltersRecords';

const TabHealthRecords = ({
  records,
  loadHealthRecords,
  professionals = [],
  filterType,
  setFilterType,
  filterArea,
  setFilterArea,
  filterDescription,
  setFilterDescription,
  types,
  areas,
  handleClearFilters,
}) => {
  /** undefined = closed; null = create new; object = view/edit existing */
  const [recordModal, setRecordModal] = useState(undefined);

  const handleSaved = () => {
    setRecordModal(undefined);
    loadHealthRecords();
  };

  const handleDeleted = () => {
    loadHealthRecords();
  };

  const searchTarget = (item) =>
    `${item.description || ''} ${item.professional || ''} ${item.area || ''}`.toLowerCase();

  const filteredRecords = records
    .filter(
      (item) =>
        (filterType ? item.type === filterType : true) &&
        (filterArea ? item.area === filterArea : true) &&
        searchTarget(item).includes(filterDescription.toLowerCase())
    )
    .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));

  // ###### RETURN VIEW
  return (
    <>
      {recordModal !== undefined && (
        <ModalRecordForm
          record={recordModal}
          areas={areas}
          professionals={professionals}
          onClose={() => setRecordModal(undefined)}
          onSaved={handleSaved}
          onDeleted={handleDeleted}
        />
      )}

      {/* Records Filters */}
      <FiltersRecords
        filterDescription={filterDescription}
        setFilterDescription={setFilterDescription}
        filterArea={filterArea}
        setFilterArea={setFilterArea}
        filterType={filterType}
        setFilterType={setFilterType}
        areas={areas}
        types={types}
        handleClearFilters={handleClearFilters}
      />

      {/* Cards View */}
      <div className="flex flex-col gap-2 md:gap-4">
        {filteredRecords.map((item) => (
          <div
            key={item.id}
            onClick={() => setRecordModal(item)}
            className="bg-white p-4 rounded-xl shadow hover:bg-gray-50 cursor-pointer transition"
          >
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-1 md:gap-2">
              <div className="flex flex-col mb-1 md:mb-0">
                <span className="text-gray-500 text-sm">{formatDate(item.date)}</span>
                <span className="text-gray-600 text-sm flex items-center gap-1">
                  {item.professional}
                  {item.professional_ref_detail && (
                    <LinkIcon className="h-3 w-3 text-gray-400 flex-shrink-0" title="Linked to a registered professional" />
                  )}
                </span>
              </div>
              <div className="flex flex-wrap gap-1 md:gap-2">
                <span className="px-2 py-1 md:px-3 md:py-1 bg-gray-700 text-white text-xs rounded-full">{item.area}</span>
                <span className={`px-2 py-1 md:px-3 md:py-1 text-white text-xs rounded-full ${TYPE_COLORS[item.type] || 'bg-gray-400'}`}>
                  {item.type}
                </span>
              </div>
            </div>
            <p className="mt-2 text-sm md:text-base text-black">
              {item.description && item.description.length > 100 ? item.description.slice(0, 100) + '...' : item.description}
            </p>
          </div>
        ))}
        {filteredRecords.length === 0 && (
          <p className="text-gray-500 px-2">No records match the current filters.</p>
        )}
      </div>

      {/* Add Button */}
      <button
        onClick={() => setRecordModal(null)}
        className="fixed bottom-20 right-6 bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-full shadow-lg"
      >
        <PlusCircleIcon className="h-8 w-8" />
      </button>
    </>
  );
};

export default TabHealthRecords;
